import { Component } from '@angular/core';
import { Announcement, AnnouncementsService } from 'src/app/services/announcements.service';

@Component({
  selector: 'app-teacher-announcements',
  templateUrl: './teacher-announcements.component.html',
  styleUrls: ['./teacher-announcements.component.css']
})
export class TeacherAnnouncementsComponent {
  items: Announcement[] = [];
  loading = false;
  errorMessage = '';
  currentIndex = 0;

  constructor(private announcementsService: AnnouncementsService) { }

  async ngOnInit() {
    await this.fetchItems();
  }

  get currentAnnouncement(): Announcement | null {
    return this.items[this.currentIndex] ?? null;
  }

  get hasMultipleAnnouncements(): boolean {
    return this.items.length > 1;
  }

  async fetchItems() {
    this.loading = true;
    this.errorMessage = '';
    try {
      this.items = await this.announcementsService.listActive();
      this.currentIndex = 0;
    } catch (error: any) {
      this.errorMessage = error?.error?.errorMessages?.[0]?.message || 'ANNOUNCEMENTS.LOAD_FAILED';
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  previousAnnouncement(): void {
    if (!this.items.length) {
      return;
    }
    this.currentIndex = this.currentIndex === 0
      ? this.items.length - 1
      : this.currentIndex - 1;
  }

  nextAnnouncement(): void {
    if (!this.items.length) {
      return;
    }
    this.currentIndex = (this.currentIndex + 1) % this.items.length;
  }

  goToAnnouncement(index: number): void {
    if (index >= 0 && index < this.items.length) {
      this.currentIndex = index;
    }
  }
}
